// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"t0-z","subtitle":"u0-z","wrapper":"v0-z","leftArrow":"w0-z","rightArrow":"x0-z"};